import { atom } from 'jotai';
import GoogleHybrid from '~/assets/images/bm_google_hybrid.png';
import GoogleRoad from '~/assets/images/bm_google_road.png';
import SatelliteOnly from '~/assets/images/bm_google_satellite_only.png';
import TerrainOnly from '~/assets/images/bm_google_terrain.png';
import { GoogleLayers, MapTilerLayers } from "~/components/Map/utils/MapConstaints";
import maptilerBrightImg from './imgs/bright-v2.png';
import maptilerStreetsImg from './imgs/streets.png';
import maptilerSatelliteImg from './imgs/satellite.png';
import maptilerOSMImg from './imgs/openstreetmap.png';
import maptilerLandscapeImg from './imgs/landscape.png';
import maptilerTonerImg from './imgs/toner-v2.png';
import maptilerTopoImg from './imgs/topo-v2.png';

export const googleBasemaps: Basemap[] = [
  {
    type: 'google',
    title: 'Google kết hợp',
    url: GoogleLayers.HYBRID,
    image: GoogleHybrid
  },
  {
    type: 'google',
    title: 'Google vệ tinh',
    url: GoogleLayers.SATELLITE_ONLY,
    image: SatelliteOnly
  },
  {
    type: 'google',
    title: 'Google đường phố',
    url: GoogleLayers.ROADMAP,
    image: GoogleRoad
  },
  {
    type: 'google',
    title: 'Google địa hình',
    url: GoogleLayers.TERRAIN,
    image: TerrainOnly
  }
]

export const maptilerBasemaps: Basemap[] = [
  {
    type: 'maptiler',
    title: MapTilerLayers.BRIGHT.name,
    url: MapTilerLayers.BRIGHT.url,
    image: maptilerBrightImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.STREETS.name,
    url: MapTilerLayers.STREETS.url,
    image: maptilerStreetsImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.SATELLITE.name,
    url: MapTilerLayers.SATELLITE.url,
    image: maptilerSatelliteImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.OSM.name,
    url: MapTilerLayers.OSM.url,
    image: maptilerOSMImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.LANDSCAPE.name,
    url: MapTilerLayers.LANDSCAPE.url,
    image: maptilerLandscapeImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.TONER.name,
    url: MapTilerLayers.TONER.url,
    image: maptilerTonerImg,
  },
  {
    type: 'maptiler',
    title: MapTilerLayers.TOPO.name,
    url: MapTilerLayers.TOPO.url,
    image: maptilerTopoImg,
  },
]


export type Basemap = {
  type: 'google' | 'maptiler';
  title: string;
  url: string;
  image: string;
}
export const selectedBasemapAtom = atom<Basemap>(maptilerBasemaps[0]);
export const showBasemapPanelAtom = atom<boolean>(false);
